import { render, staticRenderFns } from "./ProzessResourceValue.vue?vue&type=template&id=5a137527"
import script from "./ProzessResourceValue.vue?vue&type=script&lang=js"
export * from "./ProzessResourceValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports